export function createTableColumns (options, common = {}) {
  return options.map(([title, dataIndex, option = {}]) => createTableColumn(title, dataIndex, { ...common, ...option }));
}

export function createTableColumn (title, dataIndex, options = {}) {
  return {
    title,
    dataIndex,
    ...options,
  };
}

export function map2SelectOptions (map, allLabel = '全部', allValue = '') {
  const options = [];
  if (allLabel !== false) {
    options.push({
      label: allLabel,
      value: allValue,
    });
  }

  options.push(...Object.keys(map).map(key => ({
    label: map[key],
    value: key,
  })));

  return {
    type: 'select',
    options,
  };
}
